import { html } from 'lit';
import { CircleGauge } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-circle-gauge')
export class PdsIconCircleGauge extends PdsIcon {
  @state()
  icon = CircleGauge;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
